export enum ViewMode {
  TOTAL_COUNTS = 'total-counts',
  COMPARE_TRAPS = 'compare-traps'
}

export const ALL_TRAPS_SELECTED_VALUE = 'all';
